/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { ScreenerBedRoom } from './ScreenerBedRoom';
import {
    ScreenerBedRoomFromJSON,
    ScreenerBedRoomFromJSONTyped,
    ScreenerBedRoomToJSON,
    ScreenerBedRoomToJSONTyped,
} from './ScreenerBedRoom';
import type { BedType } from './BedType';
import {
    BedTypeFromJSON,
    BedTypeFromJSONTyped,
    BedTypeToJSON,
    BedTypeToJSONTyped,
} from './BedType';
import type { Occupancy } from './Occupancy';
import {
    OccupancyFromJSON,
    OccupancyFromJSONTyped,
    OccupancyToJSON,
    OccupancyToJSONTyped,
} from './Occupancy';
import type { BedPccMapping } from './BedPccMapping';
import {
    BedPccMappingFromJSON,
    BedPccMappingFromJSONTyped,
    BedPccMappingToJSON,
    BedPccMappingToJSONTyped,
} from './BedPccMapping';
import type { BedNoteCreatedByUser } from './BedNoteCreatedByUser';
import {
    BedNoteCreatedByUserFromJSON,
    BedNoteCreatedByUserFromJSONTyped,
    BedNoteCreatedByUserToJSON,
    BedNoteCreatedByUserToJSONTyped,
} from './BedNoteCreatedByUser';

/**
 * 
 * @export
 * @interface Bed
 */
export interface Bed {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    bed_types: Array<BedType>;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    active_occupancy_list: Array<Occupancy>;
    /**
     * 
     */
    room_id?: string;
    /**
     * 
     */
    room?: ScreenerBedRoom;
    /**
     * 
     */
    note?: string;
    /**
     * ID of the user who created the note
     */
    note_created_by_user_id?: string;
    /**
     * Timestamp when the note was created
     */
    note_created_at?: Date;
    /**
     * 
     */
    note_created_by_user?: BedNoteCreatedByUser;
    /**
     * 
     */
    pcc_mapping?: BedPccMapping;
}

/**
 * Check if a given object implements the Bed interface.
 */
export function instanceOfBed(value: object): value is Bed {
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('bed_types' in value) || value['bed_types'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('active_occupancy_list' in value) || value['active_occupancy_list'] === undefined) return false;
    return true;
}

export function BedFromJSON(json: any): Bed {
    return BedFromJSONTyped(json, false);
}

export function BedFromJSONTyped(json: any, ignoreDiscriminator: boolean): Bed {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'facility_id': json['facility_id'],
        'bed_types': ((json['bed_types'] as Array<any>).map(BedTypeFromJSON)),
        'name': json['name'],
        'active_occupancy_list': ((json['active_occupancy_list'] as Array<any>).map(OccupancyFromJSON)),
        'room_id': json['room_id'] == null ? undefined : json['room_id'],
        'room': json['room'] == null ? undefined : ScreenerBedRoomFromJSON(json['room']),
        'note': json['note'] == null ? undefined : json['note'],
        'note_created_by_user_id': json['note_created_by_user_id'] == null ? undefined : json['note_created_by_user_id'],
        'note_created_at': json['note_created_at'] == null ? undefined : (parseDateTime(json['note_created_at'])),
        'note_created_by_user': json['note_created_by_user'] == null ? undefined : BedNoteCreatedByUserFromJSON(json['note_created_by_user']),
        'pcc_mapping': json['pcc_mapping'] == null ? undefined : BedPccMappingFromJSON(json['pcc_mapping']),
    };
}

export function BedToJSON(json: any): Bed {
    return BedToJSONTyped(json, false);
}

export function BedToJSONTyped(value?: Bed | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'bed_types': ((value['bed_types'] as Array<any>).map(BedTypeToJSON)),
        'name': value['name'],
        'active_occupancy_list': ((value['active_occupancy_list'] as Array<any>).map(OccupancyToJSON)),
        'room_id': value['room_id'],
        'room': ScreenerBedRoomToJSON(value['room']),
        'note': value['note'],
        'note_created_by_user_id': value['note_created_by_user_id'],
        'note_created_at': value['note_created_at'] == null ? value['note_created_at'] : serializeDateTime(value['note_created_at']),
        'note_created_by_user': BedNoteCreatedByUserToJSON(value['note_created_by_user']),
        'pcc_mapping': BedPccMappingToJSON(value['pcc_mapping']),
    };
}

